export const categoriesCity = [
  { name: "Date", bg: "bg-primary-500", text: "text-primary-500", border: "border-primary-500", key: "d" },
  { name: "ExamName", bg: "bg-red-500", text: "text-red-500", border: "border-red-500", key: "e" },
  { name: "ExamType", bg: "bg-green-500", text: "text-green-500", border: "border-green-500", key: "t" },
  { name: "PrescType", bg: "bg-yellow-500", text: "text-yellow-500", border: "border-yellow-500", key: "p" },
  { name: "RPPS", bg: "bg-purple-500", text: "text-purple-500", border: "border-purple-500", key: "r" },
  { name: "Secu", bg: "bg-pink-500", text: "text-pink-500", border: "border-pink-500", key: "s" },
  { name: "Info", bg: "bg-cyan-500", text: "text-cyan-500", border: "border-cyan-500", key: "i" },
  { name: "QSP", bg: "bg-lime-500", text: "text-lime-500", border: "border-lime-500", key: "q" },
  { name: "Frequency", bg: "bg-teal-500", text: "text-teal-500", border: "border-teal-500", key: "f" },
  { name: "Schedule", bg: "bg-sky-500", text: "text-sky-500", border: "border-sky-500", key: "h" },
  { name: "Urgency", bg: "bg-orange-500", text: "text-orange-500", border: "border-orange-500", key: "u" },
  { name: "Address", bg: "bg-red-700", text: "text-red-700", border: "border-red-700", key: "a" },
  { name: "ZipCode", bg: "bg-orange-700", text: "text-orange-700", border: "border-orange-700", key: "z" },
  { name: "City", bg: "bg-yellow-700", text: "text-yellow-700", border: "border-yellow-700", key: "c" },
];

export const categoriesClinic = [
  { name: "PatientFirstname", bg: "bg-red-500", text: "text-red-500", border: "border-red-500", key: "q" },
  { name: "PatientBirthFirstname", bg: "bg-orange-500", text: "text-orange-500", border: "border-orange-500", key: "w" },
  { name: "PatientLastname", bg: "bg-yellow-500", text: "text-yellow-500", border: "border-yellow-500", key: "e" },
  { name: "PatientBirthLastname", bg: "bg-green-500", text: "text-green-500", border: "border-green-500", key: "r" },
  { name: "PatientBirthdate", bg: "bg-teal-500", text: "text-teal-500", border: "border-teal-500", key: "t" },
  { name: "PatientSexe", bg: "bg-primary-500", text: "text-primary-500", border: "border-primary-500", key: "y" },
  { name: "PatientAdress", bg: "bg-indigo-500", text: "text-indigo-500", border: "border-indigo-500", key: "u" },
  { name: "SSN", bg: "bg-purple-500", text: "text-purple-500", border: "border-purple-500", key: "i" },
  { name: "EstablishmentName", bg: "bg-pink-500", text: "text-pink-500", border: "border-pink-500", key: "o" },
  { name: "PrescriberFirstname", bg: "bg-red-600", text: "text-red-600", border: "border-red-600", key: "p" },
  { name: "PrescriberLastname", bg: "bg-orange-600", text: "text-orange-600", border: "border-orange-600", key: "a" },
  { name: "PrescriberRPPS", bg: "bg-yellow-600", text: "text-yellow-600", border: "border-yellow-600", key: "s" },
  { name: "Sampler", bg: "bg-green-600", text: "text-green-600", border: "border-green-600", key: "d" },
  { name: "SamplingDate", bg: "bg-teal-600", text: "text-teal-600", border: "border-teal-600", key: "f" },
  { name: "SamplingTime", bg: "bg-primary-600", text: "text-primary-600", border: "border-primary-600", key: "g" },
  { name: "ExamName", bg: "bg-indigo-600", text: "text-indigo-600", border: "border-indigo-600", key: "h" },
  { name: "Service", bg: "bg-purple-600", text: "text-purple-600", border: "border-purple-600", key: "b" },
  { name: "Room", bg: "bg-pink-600", text: "text-pink-600", border: "border-pink-600", key: "c" },
  { name: "IPP", bg: "bg-red-700", text: "text-red-700", border: "border-red-700", key: "1" },
  { name: "AdmissionNumber", bg: "bg-orange-700", text: "text-orange-700", border: "border-orange-700", key: "2" },
  { name: "AdmissionDate", bg: "bg-yellow-700", text: "text-yellow-700", border: "border-yellow-700", key: "3" },
  { name: "Info", bg: "bg-green-700", text: "text-green-700", border: "border-green-700", key: "4" },
  { name: "Treatments", bg: "bg-teal-700", text: "text-teal-700", border: "border-teal-700", key: "5" },
  { name: "Date", bg: "bg-primary-700", text: "text-primary-700", border: "border-primary-700", key: "6" },
  { name: "Weight", bg: "bg-indigo-700", text: "text-indigo-700", border: "border-indigo-700", key: "7" },
  { name: "Height", bg: "bg-purple-700", text: "text-purple-700", border: "border-purple-700", key: "8" },
  { name: "RecordNumber", bg: "bg-pink-700", text: "text-pink-700", border: "border-pink-700", key: "9" },
  { name: "PrescriptionNumber", bg: "bg-red-800", text: "text-red-800", border: "border-red-800", key: "0" },
];

export const categoriesForType = (type) => (type === "clinic" ? categoriesClinic : categoriesCity);

export const criticalCategoriesForType = (type) =>
  type === "clinic"
    ? [
        "PatientFirstname",
        "PatientLastname",
        "PatientBirthdate",
        "PatientSexe",
        "SSN",
        "EstablishmentName",
        "PrescriberFirstname",
        "PrescriberLastname",
        "PrescriberRPPS",
        "SamplingDate",
        "SamplingTime",
        "ExamName",
        "Service",
        "Room",
        "IPP",
        "AdmissionNumber",
        "AdmissionDate",
        "Date",
        "RecordNumber",
        "PrescriptionNumber",
        "Weight",
        "Height",
      ]
    : ["Date", "ExamName", "RPPS"];

export const categoryHotkey = (key) => (["j", "k", "l", "v", "m", "n", "z"].includes(key) ? `shift+${key}` : key);

export const getTag = (label) => {
  if (label?.startsWith("B-")) return ["B", label.substring(2)];
  if (label?.startsWith("I-")) return ["I", label.substring(2)];

  return ["O", label];
};

export const trimLineBreakLabels = (labels, tokens) => {
  let i = 0;
  while (i < labels.length) {
    const [, name] = getTag(labels[i]);
    if (!name || name === "O") {
      i++;
      continue;
    }

    let end = i;
    while (end + 1 < labels.length && labels[end + 1] === `I-${name}`) end++;

    let start = i;
    while (start <= end && tokens[start] === "\n") labels[start++] = "O";
    let last = end;
    while (last >= start && tokens[last] === "\n") labels[last--] = "O";
    if (start <= last && start > i) labels[start] = `B-${name}`;

    i = end + 1;
  }

  return labels;
};

export const mergePolygons = (polygons) => {
  let [minX, minY] = [Infinity, Infinity];
  let [maxX, maxY] = [-Infinity, -Infinity];

  for (const polygon of polygons) {
    for (const point of polygon) {
      [minX, minY] = [Math.min(minX, point.X), Math.min(minY, point.Y)];
      [maxX, maxY] = [Math.max(maxX, point.X), Math.max(maxY, point.Y)];
    }
  }

  return [
    { X: minX, Y: minY },
    { X: maxX, Y: minY },
    { X: maxX, Y: maxY },
    { X: minX, Y: maxY },
  ];
};

export const groupEntities = (doc) => {
  const groups = {};
  if (!doc?.labels || !doc?.tokens) return groups;

  for (let i = 0; i < doc.labels.length; i++) {
    const [bi, tag] = getTag(doc.labels[i]);
    if (tag === "O") continue;

    if (!groups[tag]) groups[tag] = { items: [] };

    const [, previousTag] = getTag(doc.labels[i - 1]);
    const lastItem = groups[tag].items[groups[tag].items.length - 1];
    if (bi === "I" && previousTag === tag && lastItem) {
      lastItem.contents.push(doc.tokens[i]);
      lastItem.indexes.push(i);
      continue;
    }

    groups[tag].items.push({ contents: [doc.tokens[i]], indexes: [i] });
  }

  return groups;
};

export const groupRecommendations = (doc) => {
  const recommendations = [];

  for (let i = 0; i < (doc?.recommendedLabels?.length || 0); i++) {
    const label = doc.recommendedLabels[i];
    if (label === null) continue;

    const [bi, tag] = getTag(label);

    const last = recommendations[recommendations.length - 1];
    const consecutive = last?.indexes[last.indexes.length - 1] === i - 1;
    if (consecutive && last?.tag === tag && (bi === "I" || tag === "O")) {
      last.tokens.push(doc.tokens[i]);
      last.indexes.push(i);
      continue;
    }

    const [, currentTag] = getTag(doc.labels[i]);
    recommendations.push({ tag, tokens: [doc.tokens[i]], indexes: [i], currentTag });
  }

  return recommendations;
};
